// Generated Mon Aug 21 2017 10:39:55 GMT+0200 (CEST)

export default {
  backend: {
    hostname: 'https://api.everviz.com'
  }
};
